<template>
  <ion-modal
    data-test="app-modal-skeleton"
    :backdrop-dismiss="false"
    :is-open="true"
    role="dialog"
    aria-hidden="true"
    aria-busy="true"
  >
    <div class="content-wrapper">
      <ion-title size="small" data-test="modal-title-skeleton">
        <ion-skeleton-text
          :animated="true"
          style="width: 60%; height: 28px"
        ></ion-skeleton-text>
      </ion-title>

      <p class="body" data-test="modal-body-skeleton">
        <ion-skeleton-text
          :animated="true"
          style="width: 100%; height: 16px; margin-bottom: 4px"
        ></ion-skeleton-text>
        <ion-skeleton-text
          :animated="true"
          style="width: 100%; height: 16px"
        ></ion-skeleton-text>
      </p>
      <div class="button-wrapper">
        <ion-skeleton-text
          data-test="modal-button"
          :animated="true"
          class="button"
          style="width: 100%; height: 44px"
        ></ion-skeleton-text>
        <ion-skeleton-text
          data-test="modal-button"
          :animated="true"
          class="button"
          style="width: 100%; height: 44px"
        ></ion-skeleton-text>
      </div>
    </div>
  </ion-modal>
</template>

<script setup lang="ts">
import { IonModal, IonTitle } from "@ionic/vue";
</script>
<style lang="scss" scoped>
@import "@/common/theme/breakpoints.scss";
.content-wrapper {
  padding: var(--spacing-24);
}
ion-modal {
  --height: auto;
  --max-width: 312px;
  border-radius: 24px;
  display: flex;
  padding-left: var(--spacing-24);
  padding-right: var(--spacing-24);
  --background: var(--background-white);
}
ion-skeleton-text {
  border-radius: 0;
  margin: auto;
}
ion-title {
  margin-bottom: var(--spacing-8);
  padding: var(--spacing-0);
}
.body {
  margin-bottom: var(--spacing-24);
  margin-top: var(--spacing-0);
}
.button-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
}
.button {
  border-radius: 8px;
}

@include breakpoint(medium) {
  ion-modal {
    --max-width: 404px;
  }
}
</style>
